const { InnerBlocks, RichText } = wp.blockEditor;
import Inspector from './inspector';

export default ({ attributes, setAttributes }) => {
  const { title, containerized, margin } = attributes;
  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`ColorCards ${margin}`}>
        <div className={`${containerized ? 'Container' : ''}`}>
          <RichText
            tagName="h2"
            className="Typography title-5 center color-blue-dark margin-base"
            value={title}
            placeholder="Título (Tag H2)"
            keepPlaceholderOnFocus
            onChange={(title) => setAttributes({ title })}
          />
          <div className="ColorCards__content">
            <InnerBlocks
              template={[['app/color-cards-item']]}
              allowedBlocks={['app/color-cards-item']}
            />
          </div>
        </div>
      </section>
    </>
  );
};
